/**
 * App mode configuration.
 *
 * REACT_APP_MODE controls which features are visible:
 *   "stats"  — default, stats-only (leaderboards, matches, players, highlights, live)
 *   "hybrid" — stats + queue, match creation, login
 */

const MODE = (process.env.REACT_APP_MODE || 'stats').toLowerCase();

export const isHybridMode = MODE === 'hybrid';

export const APP_MODE = MODE;
